import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import {
  FormInterface,
  FormSubEntityInterface,
} from 'src/shared/types/entities/form-interface'

export const useUpdateFormSubEntityProp = <
  SubEntity extends FormSubEntityInterface,
  Key extends keyof SubEntity,
>(
  formEntity: FormInterface,
  updatedSubEntity: SubEntity,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (prop: Key) => (value: SubEntity[Key]) => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.map(subEntity =>
        subEntity.id === updatedSubEntity.id
          ? { ...subEntity, [prop]: value }
          : subEntity,
      ),
    })
  }
}

export const useUpdateFormSubEntityProps = <
  SubEntity extends FormSubEntityInterface,
>(
  formEntity: FormInterface,
  updatedSubEntity: SubEntity,
) => {
  const updateEntity = useUpdateEntity<FormInterface>()

  return (updatedProps: Partial<SubEntity>) => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.map(subEntity =>
        subEntity.id === updatedSubEntity.id
          ? { ...subEntity, ...updatedProps }
          : subEntity,
      ),
    })
  }
}
